export default "__VITE_ASSET__3keCjS18__"